module.exports = __webpack_public_path__ + "img/phb.6898ef67.png";